import React, { Component } from 'react';
import './FullScreenNotification.css';
import {Grid} from "@material-ui/core";


class FullScreenNotification extends Component {

    confirm = () => {
        this.props.parentCallback(false);
    }

    render() {
        return (
            <Grid>circleDiv
                <Grid>
                    <div style={{display:'flex'}}>
                        <div className="mainOuterDiv">
                            <div>
                                <div className="circle">
                                     <div className="circle_count_content">{localStorage.getItem('newOrderCount')}</div>
                                    <div className="circle_text_content">{localStorage.getItem('newOrderCount') > 1 ? "Orders" : "Order"}</div>
                                 </div>
                             </div>
                            <div className="orderReceivedText">You have a new UBMe order!</div>
                            <div className="divButton">
                                <button className="btnConfirmOrder" onClick={() => this.confirm()}>Confirm</button>
                            </div>
                         </div>
                    </div>
                </Grid>
            </Grid>
        );
    }
}

export default FullScreenNotification;